import { css } from "styled-components"
import { colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import {
  Slide,
  SlideContent,
  SliderWrapper,
} from "@gamigo/gatsby-theme-strapi/src/components/slider/slider-elements"

export const SectionWrapperStyles = css`
  position: relative;

  ${SliderWrapper} {
    z-index: 100;
  }

  ${Slide} {
    height: 1085px;
    justify-content: flex-start;
  }

  ${SlideContent} {
    position: relative;
    padding: 30px;
    max-width: 1500px; // TODO: sync value with ContentWrapper
    margin-top: 450px;
    & > div {
      max-width: 544px;
      z-index: 111;
      padding: 0 35px;
    }
    &:before {
      display: block;
      position: absolute;
      content: "";
      height: 100%;
      width: 544px;
      z-index: 110;
      border: 1px solid ${colors.blue};
      background: radial-gradient(
        ellipse at center bottom,
        ${colors.categoriesBarGradientStart} 10%,
        ${colors.categoriesBarGradientEnd} 85%
      );
    }
    h2 {
      font-size: ${fonts.sizes[5]};
    }
  }
`

export const ContentWrapperStyles = css`
  position: absolute;
  top: 259px;
  z-index: 101;
  left: 50%;
  transform: translate(-50%, 0px);
`

export const DescriptionStyles = css``
